import React from 'react';
import { Box, Icon, IconWrapper } from '@honda-canada/design-system-react';
import PropTypes from 'prop-types';
import themeStyles, { ErrorCopy } from './PriceComponent.styles';
import { useAppName } from '../../utils/sitecoreContext';
import { ACURA_SITE_NAME, HONDA_SITE_NAME, PE_SITE_NAME } from '../../utils/constants';

const Container = themeStyles.apply(Box, 'Container');
const ErrorIcon = themeStyles.apply(Icon, 'ErrorIcon');

const Error = ({
  message,
  horizontalAlignment,
  verticalAlignment,
  errorStyles,
  showSellingPriceDisclaimer,
  isErrorIconFilled,
  errorIconName,
}) => {
  const appName = useAppName();
  let isIconFilled = false;
  switch (appName) {
    case ACURA_SITE_NAME:
      isIconFilled = false;
      break;
    case HONDA_SITE_NAME:
    case PE_SITE_NAME:
      isIconFilled = true;
      break;
    default:
      isIconFilled = false;
      break;
  }

  return (
    <Container
      horizontalAlignment={horizontalAlignment}
      verticalAlignment={verticalAlignment}
      data-testid="pricing-error"
      priceDisclaimerHeight={showSellingPriceDisclaimer ? '46px' : errorStyles?.container?.height}
      hasPriceDisclaimer={showSellingPriceDisclaimer}
      alignItems={showSellingPriceDisclaimer ? 'baseline' : 'start'}
      {...errorStyles?.container}
    >
      <IconWrapper size="iconWrapper.zero">
        <ErrorIcon name={errorIconName} filled={isErrorIconFilled ?? isIconFilled} />
      </IconWrapper>
      <ErrorCopy
        data-testid="price-error-message"
        size={errorStyles?.copy?.size ?? 'extraSmall'}
        styles={errorStyles?.copy}
      >
        {message}
      </ErrorCopy>
    </Container>
  );
};

Error.propTypes = {
  message: PropTypes.string,
  horizontalAlignment: PropTypes.oneOf(['left', 'center', 'right']),
  verticalAlignment: PropTypes.oneOf(['center', 'start', 'end']),
  errorStyles: PropTypes.shape({
    container: PropTypes.shape({}),
    copy: PropTypes.shape({}),
  }),
  showSellingPriceDisclaimer: PropTypes.bool,
  isErrorIconFilled: PropTypes.bool,
  errorIconName: PropTypes.string,
};

export default Error;
